import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection, limit, documentId } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
import Lodinging from "../components/loading";
import Loadingimg from '../components/loadingimg';
import './dashboard.css';
import './upcomingtask.css';
import axios from 'axios'; 
import { MdSearch, MdAdd,MdSettings } from 'react-icons/md';
 
export default function Upcomingtask() {
    const navigate = useNavigate();
    const [guid, setGuid] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [Selected, setSelected] = useState('Dashboard');
    return (
        <div className='upcoming-task-body'>
               <div className="dashboard-items">
                                    <div className='items-hd'>
                                        <div className="item-title-text">Upcoming task</div>
                                            <MdSettings title='Settings' onClick={() => navigate('/upcoming-task')} className='settings-img' />
                                    </div>
                                </div>
        </div>
    );
}
